import { createQueryKeys } from '@lukemorales/query-key-factory';

export const principalCandidatesListQueries = createQueryKeys('principal-candidates-list', {
  list: (params: { schoolId: number; page?: number; ordering?: string }) => ({
    queryKey: [params.schoolId, params.page, params.ordering],
  }),
});
